import { forwardRef } from 'react';
/**
 * Typed wrapper around forwardRef for generic components
 *
 * Taken from https://fettblog.eu/typescript-react-generic-forward-refs/
 */
// eslint-disable-next-line @typescript-eslint/ban-types
export function genericForwardRef(render, displayName) {
    const newElem = forwardRef(render);
    if (displayName) {
        newElem.displayName = displayName;
    }
    return newElem;
}
//# sourceMappingURL=generic-forward-ref.js.map